<template>
  <div class="app-topbar px-4 d-flex align-items-center justify-content-between">
    <!-- Left: Page title -->
    <div class="d-flex align-items-center gap-3">
      <nav aria-label="breadcrumb" class="mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item text-xs text-secondary">Pages</li>
          <li class="breadcrumb-item text-xs active font-weight-bold" aria-current="page">
            {{ pageTitle }}
          </li>
        </ol>
      </nav>
    </div>

    <!-- Right: actions -->
    <div class="d-flex align-items-center gap-3">
      <!-- User menu -->
      <div class="topbar-user" v-if="user" @click="toggleMenu" ref="userMenu">
        <img v-if="user.picture" :src="user.picture" :alt="user.name" class="topbar-avatar-img" referrerpolicy="no-referrer" />
        <div v-else class="topbar-avatar-circle d-flex align-items-center justify-content-center">
          <i class="fas fa-user" style="font-size:0.8rem;"></i>
        </div>

        <!-- Dropdown -->
        <div class="topbar-dropdown" v-if="menuOpen">
          <div class="topbar-dropdown-header">
            <img v-if="user.picture" :src="user.picture" :alt="user.name" class="topbar-dropdown-avatar" referrerpolicy="no-referrer" />
            <div>
              <div class="topbar-dropdown-name">{{ user.name }}</div>
              <div class="topbar-dropdown-email">{{ user.email }}</div>
            </div>
          </div>
          <div class="topbar-dropdown-divider"></div>
          <button class="topbar-dropdown-item text-danger" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Sign out
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "AppTopBar",
  data() {
    return { menuOpen: false };
  },
  computed: {
    pageTitle() {
      const routeName = this.$route.name;
      if (!routeName) return "Dashboard";
      const menus = this.$store.state.menuAccess || [];
      const match = menus.find((m) => {
        const name = String(m.routeName || m.route_name || "").trim();
        return name === routeName;
      });
      if (match) {
        return match.menuName || match.menu_name || routeName;
      }
      return routeName;
    },
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    ...mapMutations(["setUser"]),
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleOutsideClick(e) {
      if (this.$refs.userMenu && !this.$refs.userMenu.contains(e.target)) {
        this.menuOpen = false;
      }
    },
    logout() {
      this.setUser(null);
      if (window.google?.accounts?.id) {
        window.google.accounts.id.disableAutoSelect();
      }
      const base = process.env.BASE_URL || "/";
      const signInPath = `${base}sign-in`.replace(/\/{2,}/g, "/");
      window.location.assign(signInPath);
    },
  },
};
</script>

<style scoped>
.app-topbar {
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
  height: 4.5rem;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

/* ── User menu ── */
.topbar-user {
  position: relative;
  cursor: pointer;
}

.topbar-avatar-img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e9ecef;
  display: block;
}

.topbar-avatar-circle {
  width: 2.2rem;
  height: 2.2rem;
  background: #e9ecef;
  border-radius: 50%;
  color: #67748e;
}

/* ── Dropdown ── */
.topbar-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  min-width: 220px;
  z-index: 200;
  overflow: hidden;
}

.topbar-dropdown-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
}

.topbar-dropdown-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.topbar-dropdown-name {
  font-size: 0.825rem;
  font-weight: 600;
  color: #344767;
  white-space: nowrap;
}

.topbar-dropdown-email {
  font-size: 0.75rem;
  color: #67748e;
  white-space: nowrap;
}

.topbar-dropdown-divider {
  border-top: 1px solid #e9ecef;
}

.topbar-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.7rem 1rem;
  font-size: 0.825rem;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
}

.topbar-dropdown-item:hover {
  background: #fff5f5;
}

.topbar-dropdown-item.text-danger {
  color: #e53e3e;
}

.breadcrumb {
  background: none;
  padding: 0;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "/";
  color: #adb5bd;
  font-size: 0.7rem;
}
</style>
